module.exports = __webpack_public_path__ + "img/step_2.4e5971bd.png";